'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getPhrasePropTypes = {};

exports.__exports = getPhrasePropTypes;
